import axios from 'axios';

// Create axios instance with default config
export const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'}/api/v1`,
  // Force HTTPS in production
  ...(import.meta.env.PROD && {
    baseURL: `${import.meta.env.VITE_API_BASE_URL?.replace('http:', 'https:') || 'https://app.peerdigital.se'}/api/v1`,
  }),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Skip redirect for manual logout calls
      if (!url.includes('/auth/logout')) {
        // Handle unauthorized access
        localStorage.removeItem('access_token');
        // Redirect to login with a query parameter to show session expired modal
        window.location.href = '/login?session_expired=true';
      }
    }
    return Promise.reject(error);
  }
);